<template>
  <div class="c-product-image" :class="{ wideContent }" ref="image">
    <a :href="product.url" :aria-label="product.plainTitle">
      <img :src="product.imageUrl" :alt="product.plainTitle" />
      <ul v-if="features.length" class="c-product-image__features">
        <li
          v-for="feature in features"
          :key="feature.value"
          :data-val="feature.value"
          class="c-product-image__feature"
        >
          <span>{{ feature.label }}</span>
        </li>
      </ul>

      <div class="c-product-image__heart-on-image" v-if="showFavoriteButton">
        <f-heart
          :id="product.id"
          :handle="product.handle"
          :is-favourite="isFavourite"
          @heart-changed="onHeartChanged"
        ></f-heart>
      </div>
    </a>
  </div>
</template>

<script>
import Product from '~/js/models/product'
import FSProduct from '~/js/models/FSProduct'
import FHeart from '~/js/components/heart'
import { favouriteProductHandles } from '~/js/templates/index/helpers'

export default {
  name: 'ComponentProductImage',
  components: {
    FHeart,
  },
  props: {
    product: {
      type: [Product, FSProduct],
      required: true,
      default: () => {
        return new Product()
      },
    },
    showFavoriteButton: { type: Boolean, default: true },
    wideContent: { type: Boolean, default: false },
    widthFixed: { type: Boolean, default: false },
  },
  data() {
    return {
      isFavourite: false,
    }
  },
  computed: {
    features() {
      return this.product.features.slice(0, 3)
    },
  },
  created() {
    this.isFavourite = favouriteProductHandles.includes(this.product.handle)
  },
  mounted() {
    this.$refs.image.style.height = this.$refs.image.clientWidth + 'px'
  },
  methods: {
    onHeartChanged($event) {
      this.isFavourite = $event
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:color';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-image {
  height: 200px;
  margin: auto auto 12px;
  max-width: 100%;
  position: relative;
  width: 200px;

  @include mixins.screen-mobile {
    &:not(.wideContent) {
      height: 120px;
      width: 120px;
    }
  }

  img {
    height: 100%;
    object-fit: contain;
    width: 100%;
  }

  &__heart-on-image {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  &__features {
    align-items: flex-end;
    bottom: 0;
    display: flex;
    flex-wrap: wrap-reverse;
    margin: -2px;
    position: absolute;
  }

  &__feature {
    padding: 2px;
    line-height: 1;

    span {
      background-color: variables.$color-brown;
      border-radius: 20px;
      color: #fff;
      font-size: 10px;
      padding: 2px 10px;
      word-break: keep-all;

      @include mixins.screen-mobile {
        font-size: 8px;
        padding: 2px 8px;
      }
    }
  }
}
</style>
